

export const enData = ` 
<div class="paragraph">
    <div class="text-box">
      <div class="text">
      This Trade-In Service ("Service") is provided by Danghuan Europe S.L., a company incorporated under Spanish law and registered at Madrid, Spain, 28045, VAT ID: B19961911, email: legal@danghuan.eu.
      </div>
      <div class="text">
      This document governs the legal framework under which consumers residing in the European Union may participate in the official trade-in program for designated smartphone purchases. The program is operated in full compliance with European Union law, particularly Directive 2011/83/EU on consumer rights and Regulation (EU) 2016/679 (GDPR) on data protection.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 1 – TERRITORIAL SCOPE AND PRODUCTS</div>
    <div class="text-box">
      <div class="text">
      1.1 The Service is available to individuals legally residing in the European Union, aged 18 years or older.
      </div>
      <div class="text">
      1.2. Participants must qualify as "consumers" under Directive 2011/83/EU.
      </div>
      <div class="text">
      1.3. One used mobile phone may be traded in per qualifying transaction.
      </div>
      <div class="text">
      1.4. Trade-in eligibility is restricted to customers purchasing promotional VIVO products on vivoonlinestore.com during the defined campaign period. Only selected VIVO products qualify.
      </div>
      <div class="text">
      1.5. The used device must be included in the list of eligible devices published on the Danghuan website and must meet functional and ownership criteria as described in Article 5.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 2 – CONTRACTUAL CONDITIONS</div>
    <div class="text-box">
      <div class="text">
      2.1. The trade-in Service is independent from any product sale and does not constitute a joint offering with any device manufacturer or retailer.
      </div>
      <div class="text">
      2.2. All service responsibilities, including logistics, evaluation, communication, payment, and data handling, lie solely with Danghuan Europe S.L.
      </div>
      <div class="text">
      2.3. Nothing in these Terms affects mandatory consumer protection rights provided under EU law.
      </div>
      <div class="text">
      2.4. Danghuan reserves the right to decline participation if fraud or policy violations are suspected, including third-party submissions made on behalf of another user.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 3 – SERVICE PARTICIPATION PROCESS</div>
    <div class="text-box">
      <div class="text">
      3.1. Consumers must initiate the trade-in process by clicking the Trade-in button on vivoonlinestore.com. This will redirect them to the trade-in portal operated by Danghuan Europe S.L., where the customer must complete the order.
      </div>
      <div class="text">
      3.2. Participants complete a self-assessment questionnaire and submit the device's IMEI.
      </div>
      <div class="text">
      3.3. Customers must provide valid SEPA bank account details (IBAN) for payment.
      </div>

      
      <div class="text">
      3.4. Failure to complete the process in time may result in automatic cancellation of the trade-in.
      </div>
      <div class="text">
      3.5. Incomplete or inaccurate submissions may result in cancellation.
      </div>
      <div class="text">
      3.6. The used device must be properly packaged according to provided shipping instructions. Shipping is prepaid and Danghuan assumes responsibility for damage or loss in transit.
      </div>
      <div class="text">
      3.7. Upon successful trade-in order placement, the customer will be automatically redirected back to vivoonlinestore.com for confirmation of payment for the VIVO's new device.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 4 – DEVICE ACCEPTANCE CONDITIONS</div>
    <div class="text-box">
      <div class="text">
      4.1. Only smartphone models listed on the eligible device list are supported.
      </div>
      <div class="text">
      4.2. Devices must meet the grading and cosmetic standards defined by Danghuan, categorized into Grade A, B, or C based on certified inspection tools and physical condition.
      </div>
      <div class="text">
      4.3. Devices must power on, have a functional touchscreen, show no major physical damage (e.g. cracks or corrosion), and must be restored to factory settings, with all security locks (PIN, iCloud, Google, Samsung, Xiaomi) disabled.
      </div>
      <div class="text">
      4.4. Devices must be the sole property of the participant and not under lease or financial contract. Devices flagged as stolen, counterfeit, or with altered IMEI will be rejected without compensation.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 5 – LOGISTICS TIMELINE AND OBLIGATIONS</div>
    <div class="text-box">
      <div class="text">
      5.1. Customers must ship their used device within 10 calendar days of successfully placing the trade-in order.
      </div>
      <div class="text">
      5.2. Danghuan will send reminder emails to the customer on Day 3 (D+3), Day 6 (D+6), and Day 9 (D+9). The reminder sent on Day 9 will be the final notification prior to automatic cancellation.
      </div>
      <div class="text">
      5.3. All devices must be shipped using the prepaid shipping label provided by the designated logistics provider (such as CORREOS, UPS, NACEX, or FEDEX), as specified in the instructions sent to the customer. Only shipments made with the authorized label and through the indicated carrier will be covered under the trade-in service's liability policy.
      </div>
      <div class="text">
      5.4. If the shipping label is not scanned by the logistics provider by Day 10, the trade-in will be automatically cancelled.
      </div>
      <div class="text">
      5.5. Devices must be packaged securely to prevent damage in transit; Danghuan provides packaging instructions but not physical materials.
      </div>
      <div class="text">
      5.6. Devices received with mismatched IMEI or different conditions than reported may result in adjusted valuation or cancellation.
      </div>
      <div class="text">
      5.7: If the customer fails to send the device within 10 days, Danghuan Europe S.L. reserves the right to close the transaction and deem the customer to have abandoned the trade-in without right to compensation.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 6 – INSPECTION, QUOTATION, ACCEPTANCE</div>
    <div class="text-box">
      <div class="text">
      6.1. Devices are inspected within 3 working days of receipt at the designated warehouse. The inspection process includes both functional diagnostics using certified tools and a visual assessment to determine cosmetic condition (Grade A, B, or C).
      </div>
      <div class="text">
      6.2. If the condition or specifications of the device differ from the customer's original submission, Danghuan Europe S.L. will send a revised quote via email, specifying the adjusted grade and rationale.
      </div>
      <div class="text">
      6.3. Customers have 7 calendar days from the notification date to accept or reject the revised quote. During this time, they may request the return of the device at no additional charge.
      </div>
      <div class="text">
      6.4. If no response is received within the 7 calender days, the revised quote will be considered tacitly accepted, and the trade-in will proceed at the updated value.
      </div>
      <div class="text">
      6.5. Devices deemed non-eligible due to irreparable damage, tampering, or ineligibility (e.g., iCloud locked, stolen, or with mismatched IMEI) will receive no valuation. Customers will have 7 calendar days from notification to request a return; otherwise, the device may be responsibly recycled.
      </div>
      <div class="text">
      6.6. Payment for the accepted devices will be issued within 3 business days from the date of acceptance, via SEPA bank transfer.
      </div>
      <div class="text">
      6.7. Device Grading Criteria (DGC): All eligible devices will be classified according to one of the following conditions, which determine the final trade-in value:
      </div>
      <div class="text1">
      • Grade A – Excellent Condition
      </div>
      <div class="text2">
       Fully functional; no technical issues.
      </div>
      <div class="text2">
       No visible damage, cracks, or heavy scratches.
      </div>
      <div class="text2">
       LCD and casing in near-perfect condition.
      </div>
      <div class="text2">
       Device turns on and operates without the need for a charger.
      </div>
      <div class="text2">
       No signs of tampering or unauthorized repairs.
      </div>
      <div class="text1">
      • Grade B – Good Condition
      </div>
      <div class="text2">
       Fully functional; minor cosmetic wear.
      </div>
      <div class="text2">
       Light scratches on the screen or casing.
      </div>
      <div class="text2">
       No cracks or deep dents.
      </div>
      <div class="text2">
       Normal operation of all hardware buttons and connectivity.
      </div>
      <div class="text2">
       May show signs of regular usage but no functional defect.
      </div>
      <div class="text1">
      • Grade C – Fair Condition
      </div>
      <div class="text2">
       Device functions but has visible external damage.
      </div>
      <div class="text2">
       Scratches, cracks on the screen or back, discoloration, or minor dents.
      </div>
      <div class="text2">
       All functions must still operate correctly (touchscreen, battery, WiFi, etc.).
      </div>
      <div class="text2">
       Acceptable for trade-in but at a significantly reduced value.
      </div>
      <div class="text1">
      • Grade D or Ineligible
      </div>
      <div class="text2">
       Device does not power on, has severe hardware defects, or is not reset/unlocked.
      </div>
      <div class="text2">
       Devices that do not meet the basic eligibility criteria (e.g., blacklisted, stolen, locked, or mismatched IMEI)
      </div>
      <div class="text">
      6.8. Devices flagged as mismatched or blacklisted IMEI will be excluded. If the customer believes this assessment is incorrect, they may submit supporting documentation within 7 calendar days for review.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 7 – PAYMENT CONDITIONS</div>
    <div class="text-box">
      <div class="text">
      7.1. Payouts are made exclusively via SEPA IBAN transfer to a bank account held in the customer's name, as submitted during the trade-in registration process.
      </div>
      <div class="text">
      7.2. The provided IBAN must be linked to a valid European financial institution and remain active for at least 12 months after submission.
      </div>
      <div class="text">
      7.3. IBANs or bank accounts not matching the customer's name will result in payment failure and potential cancellation of the trade-in.
      </div>
      <div class="text">
      7.4. Danghuan Europe S.L. shall not be liable for delays or errors caused by incomplete, incorrect, or expired banking details.
      </div>
      <div class="text">
      7.5. The customer is solely responsible for providing accurate and complete payment information, including a valid SEPA IBAN registered in their own name. Danghuan Europe S.L. shall not be held liable for any payment delays, failures, or misdirected transfers caused by incorrect, incomplete, expired, or unauthorized bank account details submitted by the customer.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 8 – LIABILITY AND RISK OF LOSS</div>
    <div class="text-box">
      <div class="text">
      8.1. Participants are required to use the prepaid shipping label and logistics provider designated by Danghuan Europe S.L. Any alternative shipping methods will void the liability coverage.
      </div>
      <div class="text">
      8.2. A device is deemed lost if it is not tracked, confirmed, or received by Danghuan Europe S.L. within 15 calendar days from the date of handover to the logistics provider.
      </div>
      <div class="text">
      8.3. This liability framework applies equally to shipments from the customer to Danghuan Europe S.L. and to any return shipments from Danghuan Europe S.L. to the customer.
      </div>
      <div class="text">
      8.4. If a confirmed loss occurs under Danghuan's logistics system, Danghuan Europe S.L. will assist the customer in filing a formal claim with the courier service.
      </div>
      <div class="text">
      8.5. Liability and compensation are strictly limited to cases where the customer used the authorized shipping label provided by Danghuan Europe S.L., and the shipping event is verifiable.
      </div>
      <div class="text">
      8.6. In such lost cases, compensation will not exceed the final appraised trade-in value of the device, as determined prior to loss confirmation.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 9 – PERSONAL DATA AND GDPR COMPLIANCE</div>
    <div class="text-box">
      <div class="text">
      9.1. All personal data provided by customers during participation in the trade-in program is processed in full compliance with Regulation (EU) 2016/679 on the protection of personal data (GDPR). Danghuan Europe S.L. acts as the Data Controller and applies appropriate technical and organizational measures to ensure data security and confidentiality.
      </div>
      <div class="text">
      9.2. Collected data includes, but is not limited to: name, surname, email address, postal address, phone number, bank account (IBAN), identification documents, IMEI of the traded-in device, and responses provided in the evaluation form.
      </div>
      <div class="text">
      9.3. The data is processed exclusively for the purposes of: identity verification, processing and evaluating the trade-in request, managing the collection and shipment of the device, customer support, accounting, and executing payment. No personal data is used for marketing purposes or transferred to third parties without explicit consent, except where required by law.
      </div>
      <div class="text">
      9.4. The data will be retained only for as long as necessary to fulfill the trade-in transaction and comply with applicable legal obligations. Unless otherwise legally required, all customer data will be erased within 30 calendar days from the completion of the trade-in process and final payment.
      </div>
      <div class="text">
      9.5. Customers are solely responsible for the secure erasure of all personal information from their devices before shipment. This includes contacts, messages, images, applications, emails, browsing history, accounts, and any confidential content.
      </div>
      <div class="text">
      9.6. The customer must also remove any active SIM and microSD memory cards and disable all security features such as screen locks, passwords, and linked cloud accounts (e.g., Apple iCloud, Google account, Samsung Find My Mobile). Failure to do so may result in the device being considered ineligible.
      </div>
      <div class="text">
      9.7. Additional information regarding data processing and customer rights (access, rectification, deletion, restriction, objection) can be found in the full Privacy Policy available at the official website of Danghuan Europe S.L.
      </div>
      <div class="text">
      9.8 For devices not properly reset, Danghuan Europe S.L. will attempt a certified data wipe process, but shall not be liable for any residual personal information.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 10 – FRAUD AND NON-COMPLIANCE POLICY</div>
    <div class="text-box">
      <div class="text">
      10.1. Submissions involving false declarations, blacklisted, leased, tampered, or unowned devices will be disqualified without compensation.
      </div>
      <div class="text">
      10.2. Danghuan Europe S.L. reserves the right to exclude such participants from current and future trade-in initiatives.
      </div>
      <div class="text">
      10.3. Legal proceedings may be initiated in cases involving fraud, identity theft, or attempts to bypass eligibility requirements for commercial purposes.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 11 – FORCE MAJEURE</div>
    <div class="text-box">
      <div class="text">
      11.1. In the event of natural disasters, government restrictions, pandemics, industrial actions, or transportation disruptions beyond reasonable control, Danghuan Europe S.L. may temporarily suspend the trade-in service without liability.
      </div>
      <div class="text">
      11.2. Any delays or failures in performance arising from such force majeure events shall not be considered a breach of contract.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 12 – GOVERNING LAW AND JURISDICTION</div>
    <div class="text-box">
      <div class="text">
      12.1. These Terms and Conditions are governed by and shall be interpreted in accordance with the laws of Spain.
      </div>
      <div class="text">
      12.2. Any disputes arising under or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of Madrid, Spain, without prejudice to the mandatory consumer protection rights in the customer's country of residence.
      </div>
    </div>
  </div>
`